import type { ApplicativeImageFinding, ImagePackageFix } from "@/domain/issue"

export const getUniqueImagePackageFixes = (
  findings?: ApplicativeImageFinding[]
): ImagePackageFix[] => {
  const uniqueFixes: ImagePackageFix[] = []

  findings?.forEach((finding) => {
    finding.remedies.forEach((fix) => {
      const isUnique = uniqueFixes.every(
        (uniqueFix) =>
          uniqueFix.packageName + uniqueFix.fixType !==
          fix.packageName + fix.fixType
      )

      if (isUnique) {
        uniqueFixes.push(fix)
      }
    })
  })

  return uniqueFixes
}
